import React, { useState } from 'react';
import { ChevronDown, ArrowRight } from 'lucide-react';

const faqs = [
  {
    question: "\"We're not sure we need a videographer...\"",
    answer: "We hear this a lot. Then couples watch their film and say it's the best money they spent. You remember the day — the video lets you feel it again. The vows your partner whispered. Your dad's speech. Your first dance. Photos are beautiful, but only a film gives you the sound, the movement, the emotion. Don't risk regretting it.",
  },
  {
    question: "How much does it cost?",
    answer: "Our packages start from £1,500 for photography, £2,000 for photo & highlight video, £2,295 for the full wedding video collection, and from £3,000 for the complete video & photo package. Every package includes full digital delivery, no travel charges, and no hidden fees. We also offer interest-free monthly payment plans so you can spread the cost. Check your date above and we'll send you our full pricing guide.",
  },
  {
    question: "Can we get the raw footage?",
    answer: "We don't release raw footage — and here's why that's a good thing. Raw clips are ungraded, unedited, and often unusable on their own. What we deliver is a beautifully crafted film you'll actually want to watch. That said, we include full-length edits of all the key moments (ceremony, speeches, first dance) so nothing is left out.",
  },
  {
    question: "What if we don't like the final film?",
    answer: "In 1000+ weddings, this hasn't happened. But we understand the worry. That's why we include a preview stage where you can request changes before the final version. We also have hundreds of five-star reviews you can browse. We take pride in getting it right — every single time.",
  },
  {
    question: "How long until we get our films and photos?",
    answer: "You'll receive a 3-4 minute sneak peek highlight within one week of your wedding, plus 30-40 sneak peek photos. Your full cinematic film and complete photo gallery are delivered within 12-15 weeks. We know the wait is hard, so we keep you updated throughout the process.",
  },
  {
    question: "Will you be in the way? We want natural photos and video.",
    answer: "This is our thing. We're not the crew that blocks the aisle or interrupts your speeches. Our team is discreet, experienced, and trained to blend in. Your guests will barely notice us — but they'll be blown away by the result. We capture real moments, not staged ones.",
  },
];

const FAQ = ({ id }) => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section id={id} data-testid="faq-section" className="py-24" style={{ backgroundColor: '#FAF8F5' }}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl">
        <div className="text-center mb-16">
          <p className="text-gold text-sm font-semibold uppercase tracking-widest mb-4">Got questions?</p>
          <h2 className="font-serif text-4xl sm:text-5xl text-gray-900 mb-4">We've got answers.</h2>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              data-testid={`faq-item-${i}`}
              className="bg-white rounded-xl border border-gray-100 overflow-hidden transition-all duration-300 hover:shadow-md"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between p-6 text-left"
              >
                <span className="text-gray-900 font-semibold pr-4">{faq.question}</span>
                <ChevronDown className={`w-5 h-5 text-gray-400 flex-shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} />
              </button>
              {openIndex === i && (
                <div className="px-6 pb-6 animate-fade-up">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                  <button
                    onClick={() => document.getElementById('availability')?.scrollIntoView({ behavior: 'smooth' })}
                    className="mt-4 text-gold hover:text-gold-light text-sm font-semibold flex items-center gap-1 transition-colors"
                  >
                    Check your date <ArrowRight className="w-4 h-4" />
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
